/**
 * Created by olegg on 03-Jul-17.
 */
import DurationService from "app/services/DurationService";
import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { TableWidget } from "./TableWidget";

export class IndustryAnalysisTrafficSourcesTableWidget extends TableWidget {
    static getWidgetMetadataType() {
        return "Table";
    }

    static getWidgetDashboardType() {
        return "Table";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    constructor() {
        super();
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    getWidgetModel() {
        const widgetModel = super.getWidgetModel();
        widgetModel.type = "Table";
        return widgetModel;
    }

    protected rowReducer(row) {
        const requestParams = this._params;
        const stateParams = {
            isWWW: "*", //for now - until fix for subdomains-domains
            duration: DurationService.getDiffSymbol(
                requestParams.from,
                requestParams.to,
                requestParams.isWindow ? "days" : "months",
            ),
            country: requestParams.country,
            key: row.Domain,
        };
        return {
            ...row,
            url: this._swNavigator.href(
                "digitalsuite_website_websiteperformance",
                Object.assign({}, stateParams, this._swNavigator.getParams()),
                {},
            ),
        };
    }
}

IndustryAnalysisTrafficSourcesTableWidget.register();
